var _rect, _path, _circle, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateReservedOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.57666,
    y: 60.1973,
    width: 57.4845,
    height: 6.29207,
    rx: 3.14604,
    fill: "url(#paint0_linear_667_8169)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1289 63.6408V16.5096C11.1289 16.4023 11.1634 16.2979 11.2273 16.2117L13.0372 13.772C13.2176 13.5289 13.571 13.5005 13.7878 13.7119L16.1094 15.9747C16.3152 16.1753 16.6475 16.1615 16.8359 15.9444L18.7498 13.7397C18.9468 13.5128 19.2981 13.5097 19.4991 13.7331L21.4949 15.9514C21.6869 16.1648 22.0188 16.1731 22.2212 15.9696L24.5143 13.6635C24.7076 13.4691 25.0215 13.4667 25.2178 13.658L27.6107 15.9903C27.8104 16.185 28.1309 16.1786 28.3227 15.9761L30.5042 13.6726C30.693 13.4733 31.0072 13.4634 31.2081 13.6506L33.7453 16.0145C33.9427 16.1984 34.2504 16.1925 34.4406 16.0012L36.7382 13.6907C36.9419 13.4859 37.2761 13.4957 37.4674 13.7121L39.4228 15.9243C39.6206 16.1481 39.9693 16.1497 40.1691 15.9276L42.1711 13.7024C42.3621 13.4901 42.6917 13.4806 42.8946 13.6815L45.2243 15.9877C45.4225 16.1839 45.7428 16.18 45.9362 15.9792L48.11 13.7214C48.319 13.5045 48.6708 13.5201 48.8597 13.7547L50.5996 15.9161C50.7845 16.1458 51.127 16.1664 51.3381 15.9606L53.706 13.6527C53.9001 13.4634 54.2098 13.4634 54.404 13.6527L57.0145 16.1972C57.1111 16.2913 57.1655 16.4204 57.1655 16.5553V25.2264C52.5525 27.581 49.3938 32.3777 49.3938 37.9122C49.3938 43.4467 52.5525 48.2435 57.1655 50.598V63.6408C57.1655 63.9169 56.9417 64.1408 56.6655 64.1408H11.6289C11.3528 64.1408 11.1289 63.9169 11.1289 63.6408Z",
    fill: "url(#paint1_linear_667_8169)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.6276,
    cy: 37.9133,
    r: 11.7961,
    fill: "url(#paint2_linear_667_8169)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6279 31.0498V39.9595L67.3229 36.6255",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.14391,
    height: 1.83764,
    rx: 0.918819,
    transform: "matrix(-1 0 0 1 17.6382 54.8291)",
    fill: "#98DCB6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.14391,
    height: 1.83764,
    rx: 0.918819,
    transform: "matrix(-1 0 0 1 22.2324 54.8291)",
    fill: "#98DCB6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.14391,
    height: 1.83764,
    rx: 0.918819,
    transform: "matrix(-1 0 0 1 26.8262 54.8291)",
    fill: "#98DCB6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.14391,
    height: 1.83764,
    rx: 0.918819,
    transform: "matrix(-1 0 0 1 31.4204 54.8291)",
    fill: "#98DCB6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.14391,
    height: 1.83764,
    rx: 0.918819,
    transform: "matrix(-1 0 0 1 36.0146 54.8291)",
    fill: "#98DCB6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.14391,
    height: 1.83764,
    rx: 0.918819,
    transform: "matrix(-1 0 0 1 40.6084 54.8291)",
    fill: "#98DCB6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.14391,
    height: 1.83764,
    rx: 0.918819,
    transform: "matrix(-1 0 0 1 45.2031 54.8291)",
    fill: "#98DCB6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.14391,
    height: 1.83764,
    rx: 0.918819,
    transform: "matrix(-1 0 0 1 49.7969 54.8291)",
    fill: "#98DCB6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.14391,
    height: 1.83764,
    rx: 0.918819,
    transform: "matrix(-1 0 0 1 54.1177 54.8291)",
    fill: "#98DCB6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 17.5056,
    height: 2.20276,
    rx: 1.10138,
    transform: "matrix(-1 0 0 1 36.0142 35.5156)",
    fill: "url(#paint3_linear_667_8169)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 19.9559,
    height: 2.20276,
    rx: 1.10138,
    transform: "matrix(-1 0 0 1 38.4644 28.3184)",
    fill: "url(#paint4_linear_667_8169)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 22.1004,
    height: 2.20276,
    rx: 1.10138,
    transform: "matrix(-1 0 0 1 40.6079 42.7139)",
    fill: "url(#paint5_linear_667_8169)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_667_8169",
    x1: 7.18302,
    y1: 66.4893,
    x2: 63.0609,
    y2: 66.4893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93D1AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_667_8169",
    x1: 34.1472,
    y1: 13.5107,
    x2: 34.1472,
    y2: 64.1408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557757,
    stopColor: "#F6FAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_667_8169",
    x1: 51.8315,
    y1: 41.6129,
    x2: 79.5989,
    y2: 41.6129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90CDAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6EDC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_667_8169",
    x1: 16.831,
    y1: 1.10138,
    x2: -1.31633,
    y2: 1.10138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABE8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96D4B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_667_8169",
    x1: 19.187,
    y1: 1.10138,
    x2: -1.50058,
    y2: 1.10138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAF7D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985436,
    stopColor: "#93D1AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_667_8169",
    x1: 21.2488,
    y1: 1.10138,
    x2: -1.66183,
    y2: 1.10138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAE7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93D0AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateReservedOn);
export default __webpack_public_path__ + "static/media/state_reserved_on.1eb2eef74cc5ad00a657ec9d96811b8e.svg";
export { ForwardRef as ReactComponent };